// extracted by mini-css-extract-plugin
export default {"label":"style_label__9JI4d","amount":"style_amount__N3t5-"};